import { Column, ColumnKeys } from './grid';
import { GridViewMetadata } from 'apps/webcomponents/src/grid/gridView/types';

export interface ExchangeProtectionWebComponentSchema {
  viewMetaData: GridViewMetadata<Column, ColumnKeys>;
  actions: Array<any>;
}

export enum QuarantineEvent {
  SAVE = 'quarantineSave',
}
export interface Dependencies {
  api: {
    type: string;
  };
  translateFn: Function;
  getTimezone: Function;
  getUserLanguage: Function;
  navigateToTasks: EventListenerOrEventListenerObject;
  navigateToSandbox: Function;
  permissions: Permissions;
  openExchangeQuarantineRestoreWindow: Function;
  openExchangeQuarantineRestoreOriginalWindow: Function;
  getCurrentUserCompany: Function;
  getActiveCompany: Function
}

export interface Permissions {
  canHaveChildCompanies: boolean;
}
